import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { NotificationStatus } from '../../../types/notifications'
import { getUrlWithVersion } from '../../../api/api'

export const markAllNotificationsRead = createAsyncThunk<
    void,
    void,
    ThunkConfig<string>
>('notificationsSlice/markAllNotificationsRead', async (_, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    try {
        await api.put(
            getUrlWithVersion(`/notifications/status`),
            {
                product_ids: null,
                status: NotificationStatus.READ,
            }
        )
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to mark all notifications as read')
    }
})